import React from 'react';

import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

import { ColumnStepper } from './ColumnStepper';
import { FieldRequirement } from './FieldRequirement';
import { InputOptions } from './InputOptions';
import { LabelText } from './LabelText';
import { LabelVisibility } from './LabelVisibility';

interface Props {
  nodeIds: string[];
}

export const CheckboxListToolbox = React.memo(({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds, (node) => ({
    props: node?.data.props || {},
  }));

  return (
    <Section name="Checkbox Settings">
      <LabelText setProps={setProps} label={props.label} inputNamePrefix="checkbox" />
      <LabelVisibility showLabel={props.showLabel} setProps={setProps} inputNamePrefix="checkbox" />
      <FieldRequirement
        setProps={setProps}
        inputNamePrefix="checkbox"
        validation={props.validation}
        label={props.label}
      />
      <ColumnStepper
        columns={props.columns}
        setProps={setProps}
        inputNamePrefix="checkbox"
        maxValue={Math.min(props.options.length, 10)}
      />
      <InputOptions inputOptions={props.options} setProps={setProps} newOptionName="Checkbox" />
    </Section>
  );
});
